import React, {useContext, useMemo} from 'react'
import {FormattedMessage} from 'react-intl'
import {OrderType} from '../../../config/constants'
import {PhotosPreviewContext} from '../../common/PhotoPreview'
import ResponsiveImg from '../../common/ResponsiveImg'
import styles from './ReviewPhotoList.scss'

const ReviewPhotoList = ({orderType, photos}: {
  orderType: OrderType
  photos?: ReadonlyArray<{ url: string, caption?: string }>
}) => {
  const openPreview = useContext(PhotosPreviewContext)!
  const onOpenPreviews = useMemo(() => [...Array(photos?.length || 1).keys()]
    .map(index => () => openPreview(photos, index)),
  [openPreview, photos]
  )
  return photos?.length
    ? <>
      <div className={[styles.scroll, 'mt-2 d-flex'].join(' ')}>
        <div className="d-flex">
        {photos.map((
          {url, caption}, index
        ) => <div key={index}
         onClick={onOpenPreviews[index]}
         className={[
           styles.container,
           'bg-white c-pointer flex-grow-0 flex-shrink-0 position-relative'
         ].filter(Boolean).join(' ')}>
          <ResponsiveImg caption={caption || ''} url={url} className="w-100"/>
        </div>)}
        </div>
      </div>
      <div className={['text-right c-pointer mt-1', orderType === OrderType.car ? 'text-van' : 'text-primary'].join(' ')}
           onClick={onOpenPreviews[0]}>
        <FormattedMessage id="review.seeAllPhotos" defaultMessage="See all review photos"/>
      </div>
    </> : ''
}

ReviewPhotoList.displayName = 'ReviewPhotoList'
export default ReviewPhotoList
